
import { getApi, Visio2Room } from "/vodalys/visio2/api";



import { debug } from "/vodalys/.jslibs/";

export const visio2PushTokenMixin = {
    data: function () {
        return {
            api: undefined,
            apiError: false,
            pushTokenMixinLog: this.log = debug("Visio2:pushTokenMixin:" + this._uid)
        }
    },
    methods: {
        async initRoom(api, roomUid, streamUid, key) {

            if (!api || !roomUid || !streamUid || !key) {
                console.warn('visio2PushTokenMixin missing some parameters')
            }

            // get api
            this.api = await getApi(api.api_key);
            if (!this.api) {
                this.apiError = true;
                return console.error("visio2 api isn't configured !!!");
            }

            // si ya des hash dans l'url, on les utilise
            const paramsMatch = window.location.hash.match(
                /#\/?(\w*)-(\w*)(?:-(\w*))?/
            );

            let [, pushHashInUrl, roomUidInUrl, streamUidinUrl] = paramsMatch ?? [];

            //si le uid de room est le même en param et dans l'url, on se co a la room avec les id dans l'url
            if (roomUidInUrl == roomUid) {
                // connect

                this.pushTokenMixinLog('connect using tokens provided byin url')
                return await this.api.connect(roomUidInUrl, streamUidinUrl, pushHashInUrl)
            }

            // sinon on utilise les ids passée en params


            this.pushTokenMixinLog('connect using provided tokens')
            return await this.api.connect(roomUid, streamUid, key)

        },
    }
}